import { useCallback } from "react";
import { AxiosError } from "axios";
import { useSubscriptionModalStore } from "@/store/subscription-modal-store";

interface UseAiApiOptions {
  onSubscriptionLimit?: () => void;
}

export function useAiApi(options?: UseAiApiOptions) {
  const openModal = useSubscriptionModalStore((state) => state.openModal);

  const handleApiCall = useCallback(
    async <T>(apiCall: () => Promise<T>): Promise<T> => {
      try {
        return await apiCall();
      } catch (error) {
        if (isSubscriptionLimitError(error)) {
          openModal();

          if (options?.onSubscriptionLimit) {
            options.onSubscriptionLimit();
          }
        }

        // Re-throw the error so the component can handle it
        throw error;
      }
    },
    [options, openModal]
  );

  return {
    handleApiCall,
  };
}
/**
 * Checks if an error is a 403 subscription limit error
 */

export function isSubscriptionLimitError(error: any): boolean {
  if (error instanceof AxiosError && error.response?.status === 403) {
    const errorMessage =
      error.response?.data?.message || error.response?.data?.error || "";
    return (
      typeof errorMessage === "string" &&
      errorMessage.toLowerCase().includes("subscription")
    );
  }
  return false;
}
